import { Parts } from './Parts';

export default Parts;
